import axios from 'axios';
import moment from 'moment';

const BASE_API = process.env.VUE_API_ROOT;

export default {
  searchInventoryCalculations(payload) {
    return axios({
      method: 'post',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/ams3-fishioninfo/part-info/search`,
      data: payload,
    }).then(r => r.data);
  },
  getInventoryCalculationErrors() {
    return axios({
      method: 'get',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/ams3-fishioninfo/part-info/errors`,
    }).then(r => r.data);
  },
  getShippingInformation(orderNumber) {
    return axios.get(`${BASE_API}/am-old-db/shipping/${orderNumber}`).then((response) => {
      response.data.forEach( e => {if(e.shipmethod) { e.shipmethod = e.shipmethod.replace('&reg;', '®') }})
      return response.data;
      })
    .catch((error) => {
      console.error(error);
      return [];
    });
  },
  getReturnShippingInformation(orderNumber) {
    return axios.get(`${BASE_API}/am-old-db/shipping/return/${orderNumber}`)
      .then((response) => {
        if (typeof response.data == 'undefined' || typeof response.data[0] == 'undefined') return null;
        return {
          trackingNumber: response.data[0].tracknum,
          shipDate: response.data[0].shiptime ? moment(response.data[0].shiptime).format('MMM Do YYYY, h:mm a') : null,
          customerFedexAccount: response.data[0].customer_fedex_account,
        };
      });
  },
  getQuotesToImport() {
    return axios.get(`${BASE_API}/am-old-db/import-quotes`)
      .then(response => response.data).catch((error) => {
        console.error(error);
        return [];
      });
  },
  importQuote(id) {
    return axios({ url: `${BASE_API}/am-old-db/import-quotes`, params: { id }, method: 'post', headers: { 'Content-Type': 'text/plain' } })
      .then((response) => {
        if (response === []) {
          return true;
        }
        return false;
      }).catch((error) => {
        console.error(error);
        return false;
      });
  },
  cancelImportingQuote(id) {
    return axios({ url: `${BASE_API}/am-old-db/cancel-import-quote`, params: { id }, method: 'post', headers: { 'Content-Type': 'text/plain' } })
      .then((response) => {
        console.log('cancel quote response', response);
        if (response === []) {
          return true;
        }
        return false;
      }).catch((error) => {
        console.error(error);
        return false;
      });
  },
  getPackingInfo(shipItemIds) {
    return axios.get(`${BASE_API}/am-old-db/shipping/packing-info/${encodeURI(shipItemIds)}`)
      .then(response => response.data).catch( e => {
        return []
      }).catch(e => {
        return 'err'
      });
  },
  getAndyMarkCash(sonum) {
    return axios.get(`${BASE_API}/am-old-db/am-cash/${sonum}`)
      .then(response => response.data)
      .catch((error) => {
          console.error(error);
      });
  },
};



// WEBPACK FOOTER //
// /src/services/fishion.js